export * from './adminNavigation';
export * from './supportNavigation';
export * from './appointment_checkin';
export * from './drug';
export * from './scan_doctor';
export * from './communication';
export * from './doctor';
export * from './test_doctor';
export default []